import React from 'react'
import { Currency } from '../../model'
import { DownChevron } from '../icons'
import { Button } from '../page'
import { CurrencySymbolImage } from './CurrencySymbolImage'

interface Props {
  currency: Currency
  onClick: () => void
}

export function CurrencyButton({ currency, onClick }: Props) {
  return (
    <Button onClick={onClick}>
      <CurrencySymbolImage symbol={currency.symbol} /> {currency.symbol} <DownChevron />
    </Button>
  )
}
